import useWidth from '@components/Hooks/useWidth';
import { isTouchEnabled } from '../../../../Theme';
import useMeasuredWidth from '../../../../hooks/useMeasuredWidth';
import { OrderProductRowLayout } from '../../products/orderProductsLayout.types';
import { resolveOrderProductRowLayout } from '../../products/orderProductsLayout.utils';

interface UseOrderProductsLayoutResult {
  containerRef: (element: HTMLElement | null) => void;
  containerWidth: number;
  layout: OrderProductRowLayout;
  hasTouchGrid: boolean;
  isGridInputReadOnly: boolean;
}

const useOrderProductsLayout = (): UseOrderProductsLayoutResult => {
  const { containerRef, width: containerWidth } = useMeasuredWidth(window.innerWidth);
  const { mobileWidth, smallWidth } = useWidth();
  const layout = resolveOrderProductRowLayout({
    containerWidth,
    isMobileViewport: mobileWidth,
    isTabletViewport: !mobileWidth && smallWidth,
  });

  return {
    containerRef,
    containerWidth,
    layout,
    hasTouchGrid: isTouchEnabled,
    isGridInputReadOnly: mobileWidth,
  };
};

export default useOrderProductsLayout;
